import * as yup from 'yup';

export const SignUpSchema = yup.object({
    name: yup
		.string()
		.required('Please enter username'),
	email: yup
		.string()
		.email()
		.required('Please enter email address!'),
	password: yup
		.string()
		.required('Please enter password!'),
    cpassword: yup
		.string()
		.required('Please enter confirm password!')
});
